import React, {useState} from 'react';
import emailjs from 'emailjs-com';


function ContactForm({props, formStyle}) {

    return (
        <form className={`${formStyle}`} action="" onSubmit={e => {
            e.preventDefault()
        }}>
            <div className="form-group">
                <input
                    type="text"
                    name="fullname"
                    placeholder="Your Name"
                    required
                />
            </div>

            <div className="form-group">
                <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    size={5}
                />
            </div>

            <div className="form-group">
                <input
                    type="text"
                    name="phone"
                    placeholder="Phone Number"
                    required
                />
            </div>


            <div className="form-group">
                <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    required
                />
            </div>

            <div className="form-group">
                <textarea
                    name="message"
                    placeholder="Your Message"
                    required
                ></textarea>
            </div>

            <div className="form-group">
                <button className="btn-default btn-small">Submit Now</button>
            </div>
        </form>
    )
}

export default ContactForm;
